import openConnection from './openConnection';
import receiveData from './receiveData';

export default [
  openConnection,
  receiveData,
];
